import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as UpdatesRoute } from './UpdatesRoute';

export default {
	actions,
	reducers,
	sagas
};
